module.exports = __webpack_public_path__ + "img/yaris-20.03a24d4c.png";